/*!
 * Libas Core Web Vitals real-user monitoring
 * Bundled dependency: web-vitals@6.0.1 attribution IIFE
 * Upstream: https://www.npmjs.com/package/web-vitals/v/6.0.1
 * npm integrity: sha512-iF3+kno3Anlqi5fPVTQk9gYLfsCiL8P69Hof+AmZyVVx00E3e/BiGVvu+EsOy6jvTLqTKuiaRloPyw0JtdKbSw==
 * Upstream dist SHA-256: 982b6c4dc33a8cef12a001f21fb602cf14b5e6b3996e01ad668d8d2b194914bf
 * web-vitals is Copyright Google LLC and licensed under Apache-2.0.
 */
(function (window, document) {
  'use strict';

var webVitals=function(t){"use strict";class n{t;i=0;o=[];l(t){if(t.hadRecentInput)return;const n=this.o[0],e=this.o.at(-1);this.i&&n&&e&&t.startTime-e.startTime<1e3&&t.startTime-n.startTime<5e3?(this.i+=t.value,this.o.push(t)):(this.i=t.value,this.o=[t]),this.t?.(t)}}const e=()=>{const t=performance.getEntriesByType("navigation")[0];if(t&&t.responseStart>0&&t.responseStart<performance.now())return t},i=t=>{if("loading"===document.readyState)return"loading";const n=e();if(n){if(t<n.domInteractive)return"loading";if(0===n.domContentLoadedEventStart||t<n.domContentLoadedEventStart)return"dom-interactive";if(0===n.domComplete||t<n.domComplete)return"dom-content-loaded"}return"complete"},o=t=>{const n=t.nodeName;return 1===t.nodeType?n.toLowerCase():n.toUpperCase().replace(/^#/,"")},a=t=>{let n="";try{for(;9!==t?.nodeType;){const e=t,i=e.id?"#"+e.id:[o(e),...Array.from(e.classList??[]).sort()].join(".");if(n.length+i.length>99)return n||i;if(n=n?i+">"+n:i,e.id)break;t=e.parentNode}}catch{}return n},r=new WeakMap;function s(t,n){let e=r.get(n);return e||(e=new WeakMap,r.set(n,e)),e.get(t)||e.set(t,new n),e.get(t)}let c=-1;const f=()=>c,l=t=>{addEventListener("pageshow",n=>{n.persisted&&(c=n.timeStamp,t(n))},!0)},u=(t,n,e,i)=>{let o,a;return r=>{n.value>=0&&(r||i)&&(a=n.value-(o??0),(a||void 0===o)&&(o=n.value,n.delta=a,n.rating=((t,n)=>t>n[1]?"poor":t>n[0]?"needs-improvement":"good")(n.value,e),t(n)))}},d=t=>{requestAnimationFrame(()=>requestAnimationFrame(t))},h=()=>e()?.activationStart??0;let g=-1;const v=new Set,p=()=>"hidden"!==document.visibilityState||document.prerendering?1/0:0,m=t=>{if("hidden"===document.visibilityState){if("visibilitychange"===t.type)for(const t of v)t();isFinite(g)||(g="visibilitychange"===t.type?t.timeStamp:0,removeEventListener("prerenderingchange",m,!0))}},y=(t=!1)=>{if(t&&(g=1/0),g<0){const t=h(),n=document.prerendering?void 0:globalThis.performance.getEntriesByType("visibility-state").find(n=>"hidden"===n.name&&n.startTime>=t)?.startTime;g=n??p(),addEventListener("visibilitychange",m,!0),addEventListener("prerenderingchange",m,!0),l(()=>{setTimeout(()=>{g=p()})})}return{get firstHiddenTime(){return g},onHidden(t){v.add(t)}}},b=(t,n=-1,i,o=0,a,r,s)=>{const c=e(),l=c?.navigationId||0;let u="navigate";i?u=i:f()>=0?u="back-forward-cache":c&&(document.prerendering||h()>0?u="prerender":document.wasDiscarded?u="restore":c.type&&(u=c.type.replace(/_/g,"-")));return{name:t,value:n,rating:"good",delta:0,entries:[],id:`v6-${Date.now()}-${Math.floor(8999999999999*Math.random())+1e12}`,navigationType:u,navigationId:o||l,navigationInteractionId:a,navigationURL:r||c?.name,navigationStartTime:s||0}},M=(t,n,e={})=>{try{const i=t.filter(t=>PerformanceObserver.supportedEntryTypes.includes(t));if(i.length>0){const t=new PerformanceObserver(t=>{queueMicrotask(()=>{const e=t.getEntries();i.length>1&&e.sort((t,n)=>t.startTime+t.duration-(n.startTime+n.duration)),n(e)})});for(const n of i)t.observe({type:n,buffered:!0,...e});return t}}catch{}},T=t=>globalThis.PerformanceObserver?.supportedEntryTypes.includes("soft-navigation")&&"function"==typeof globalThis.PerformanceSoftNavigation?.prototype?.getLargestInteractionContentfulPaint&&t&&t.reportSoftNavs,E=(t,n)=>{if(t.set(n.navigationId,n),t.size>2){const n=t.keys().next().value;void 0!==n&&t.delete(n)}},D=t=>{let n=!1;return()=>{n||(t(),n=!0)}};class w{u}const S=t=>{document.prerendering?addEventListener("prerenderingchange",t,!0):t()},k=[1800,3e3],L=(t,n={})=>{const e=T(n);S(()=>{const i=s(n,w),o=y();let a,r=b("FCP");const c=M(["paint"],t=>{for(const n of t)"first-contentful-paint"===n.name&&(c.disconnect(),n.startTime<o.firstHiddenTime&&(r.value=Math.max(n.startTime-h(),0),r.entries.push(n),r.navigationId=n.navigationId||r.navigationId,a(!0)))});if(c&&(a=u(t,r,k,n.reportAllChanges),l(e=>{r=b("FCP",-1,"back-forward-cache",r.navigationId,r.navigationInteractionId,r.navigationURL,f()),a=u(t,r,k,n.reportAllChanges),d(()=>{r.value=performance.now()-e.timeStamp,a(!0)})})),e){M(["soft-navigation"],e=>{e.forEach(e=>{i.u&&e.navigationId&&E(i.u,e);const o=Math.max((e.presentationTime||e.paintTime||0)-e.startTime,0);r=b("FCP",o,"soft-navigation",e.navigationId,e.interactionId,e.name,e.startTime),a=u(t,r,k,n.reportAllChanges),a(!0)})},n)}})},P=[.1,.25],F=t=>t.find(t=>1===t.node?.nodeType)||t[0];let _=0,B=1/0,C=0;const I=t=>{for(const n of t)n.interactionId&&(B=Math.min(B,n.interactionId),C=Math.max(C,n.interactionId),_=C?(C-B)/7+1:0)};let O;const j=()=>O?_:performance.interactionCount??0,A=()=>{"interactionCount"in performance||O||(O=M(["event"],I,{durationThreshold:0}))};let q=0;class N{h=[];v=new Map;p;m;M(){q=j(),this.h.length=0,this.v.clear()}T(t){const n=j()-q,e=Math.min(this.h.length-1,Math.floor(n/50));return!n||-1!==e||"soft-navigation"!==t&&"back-forward-cache"!==t?this.h[e]:{D:8,id:-1,entries:[]}}l(t){if(this.p?.(t),!t.interactionId&&"first-input"!==t.entryType)return;const n=this.h.at(-1);let e=this.v.get(t.interactionId);if(e||this.h.length<10||t.duration>n.D){if(e?t.duration>e.D?(e.entries=[t],e.D=t.duration):t.duration===e.D&&t.startTime===e.entries[0].startTime&&e.entries.push(t):(e={id:t.interactionId,entries:[t],D:t.duration},this.v.set(e.id,e),this.h.push(e)),this.h.sort((t,n)=>n.D-t.D),this.h.length>10){const t=this.h.splice(10);for(const n of t)this.v.delete(n.id)}this.m?.(e)}}}const W=t=>{const n="requestIdleCallback"in globalThis?1e3:0,e=globalThis.requestIdleCallback||setTimeout,i=globalThis.cancelIdleCallback||clearTimeout;if("hidden"===document.visibilityState)t();else{const o=D(t);let a=-1;const r=()=>{i(a),o()};addEventListener("visibilitychange",r,{once:!0,capture:!0}),a=e(()=>{removeEventListener("visibilitychange",r,{capture:!0}),o()},{timeout:n})}},R=[200,500];class U{p;u;l(t){this.p?.(t)}}const V=[2500,4e3],$=[800,1800],x=t=>{document.prerendering?S(()=>x(t)):"complete"!==document.readyState?addEventListener("load",()=>x(t),!0):setTimeout(t)};return t.CLSThresholds=P,t.FCPThresholds=k,t.INPThresholds=R,t.LCPThresholds=V,t.TTFBThresholds=$,t.onCLS=(t,e={})=>{const o=s(e=Object.assign({},e),n),r=new WeakMap;o.t=t=>{if(t?.sources?.length){const n=F(t.sources),i=n?.node;if(i){const t=e.generateTarget?.(i)??a(i);r.set(n,t)}}};((t,e={})=>{const i=y();L(D(()=>{let o,a=b("CLS",0);const r=s(e,n),c=(n,i,s,c,f)=>{a=b("CLS",0,n,i,s,c,f),r.i=0,o=u(t,a,P,e.reportAllChanges)},h=(t=!1)=>{r.i>a.value&&(a.value=r.i,a.entries=r.o),o(t)},g=t=>{h(!0),c("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime)},v=t=>{for(const n of t)"soft-navigation"!==n.entryType?r.l(n):g(n);h()},p=["layout-shift"];T(e)&&p.push("soft-navigation");const m=M(p,v);m&&(o=u(t,a,P,e.reportAllChanges),i.onHidden(()=>{v(m.takeRecords()),o(!0)}),l(()=>{c("back-forward-cache",a.navigationId,a.navigationInteractionId,a.navigationURL,f()),d(o)}),setTimeout(o))}))})(n=>{t((t=>{let n={};if(t.entries.length){const e=t.entries.reduce((t,n)=>t.value>n.value?t:n);if(e?.sources?.length){const t=F(e.sources);t&&(n={largestShiftTarget:r.get(t),largestShiftTime:e.startTime,largestShiftValue:e.value,largestShiftSource:t,largestShiftEntry:e,loadState:i(e.startTime)})}}return Object.assign(t,{attribution:n})})(n))},e)},t.onFCP=(t,n={})=>{const o=s(n=Object.assign({},n),w);T(n)&&(o.u=new Map);L(n=>{t((t=>{let n={timeToFirstByte:0,firstByteToFCP:t.value,loadState:i(f())};if("soft-navigation"!==t.navigationType){if(t.entries.length){const o=e(),a=t.entries.at(-1);if(o){const e=o.responseStart,r=o.activationStart||0,s=Math.max(0,e-r);n={timeToFirstByte:s,firstByteToFCP:t.value-s,loadState:i(t.entries[0].startTime),navigationEntry:o,fcpEntry:a}}}}else{const e=o.u?.get(t.navigationId);e&&(n={timeToFirstByte:0,firstByteToFCP:t.value,loadState:"complete",navigationEntry:e})}return Object.assign(t,{attribution:n})})(n))},n)},t.onINP=(t,n={})=>{const e=s(n=Object.assign({},n),N);let o=[],r=[],c=0;const d=new WeakMap,h=new WeakMap;let g=!1;const v=()=>{g||(W(p),g=!0)},p=()=>{const t=new Set(e.h.map(t=>d.get(t.entries[0]))),n=r.length-10;r=r.filter((e,i)=>i>=n||t.has(e));const i=new Set;for(const t of r){const n=m(t.startTime,t.processingEnd);for(const t of n)i.add(t)}o=o.filter(t=>t.startTime>c||i.has(t)),g=!1};e.p=t=>{const e=t.startTime+t.duration;let i;c=Math.max(c,t.processingEnd);for(let o=r.length-1;o>=0;o--){const a=r[o];if(Math.abs(e-a.renderTime)<=8){i=a,i.startTime=Math.min(t.startTime,i.startTime),i.processingStart=Math.min(t.processingStart,i.processingStart),i.processingEnd=Math.max(t.processingEnd,i.processingEnd),n.includeProcessedEventEntries&&i.entries.push(t);break}}i||(i={startTime:t.startTime,processingStart:t.processingStart,processingEnd:t.processingEnd,renderTime:e,entries:n.includeProcessedEventEntries?[t]:[]},r.push(i)),(t.interactionId||"first-input"===t.entryType)&&d.set(t,i),v()},e.m=t=>{if(!h.get(t)){const e=t.entries.find(t=>t.target)?.target;if(e){const i=n.generateTarget?.(e)??a(e);h.set(t,i)}else{const n=t.entries.find(t=>t.targetSelector)?.targetSelector;n&&h.set(t,n)}}};const m=(t,n)=>{const e=[];for(const i of o)if(!(i.startTime+i.duration<t)){if(i.startTime>n)break;e.push(i)}return e},E=t=>{if(0===t.entries.length){const n=t.navigationStartTime||0,e={processedEventEntries:[],longAnimationFrameEntries:[],inputDelay:0,processingDuration:0,presentationDelay:t.value,loadState:i(n)};return Object.assign(t,{attribution:e})}const n=t.entries[0],o=d.get(n),a=o.processingStart,r=Math.max(n.startTime+n.duration,a),s=Math.min(o.processingEnd,r),c=o.entries.sort((t,n)=>t.processingStart-n.processingStart),f=m(n.startTime,s),l=e.v.get(n.interactionId),u={interactionTarget:h.get(l),interactionType:n.name.startsWith("key")?"keyboard":"pointer",interactionTime:n.startTime,nextPaintTime:r,processedEventEntries:c,longAnimationFrameEntries:f,inputDelay:a-n.startTime,processingDuration:s-a,presentationDelay:r-s,loadState:i(n.startTime),longestScript:void 0,totalScriptDuration:void 0,totalStyleAndLayoutDuration:void 0,totalPaintDuration:void 0,totalUnattributedDuration:void 0};return(t=>{const n=t.interactionTime,e=t.nextPaintTime;if(!t.longAnimationFrameEntries?.length||!n||!e)return;const i=t.inputDelay,o=t.processingDuration;let a,r,s=0,c=0,f=0,l=0;for(const e of t.longAnimationFrameEntries){c=c+e.startTime+e.duration-e.styleAndLayoutStart;for(const t of e.scripts){const e=t.startTime+t.duration;if(e<n)continue;const f=e-Math.max(n,t.startTime),u=t.duration?f/t.duration*t.forcedStyleAndLayoutDuration:0;s+=f-u,c+=u,f>l&&(r=t.startTime<n+i?"input-delay":t.startTime>=n+i+o?"presentation-delay":"processing-duration",a=t,l=f)}}const u=t.longAnimationFrameEntries.at(-1),d=u?u.startTime+u.duration:0;d>=n+i+o&&(f=e-d),a&&r&&(t.longestScript={entry:a,subpart:r,intersectingDuration:l}),t.totalScriptDuration=s,t.totalStyleAndLayoutDuration=c,t.totalPaintDuration=f,t.totalUnattributedDuration=e-n-s-c-f})(u),Object.assign(t,{attribution:u})};M(["long-animation-frame"],t=>{o=o.concat(t),v()},n),((t,n={})=>{if(!globalThis.PerformanceEventTiming||!("interactionId"in PerformanceEventTiming.prototype))return;const e=y();S(()=>{A();let i,o=b("INP");const a=s(n,N),r=(e,r,s,c,f)=>{a.M(),o=b("INP",-1,e,r,s,c,f),i=u(t,o,R,n.reportAllChanges)},c=()=>{const t=a.T(o.navigationType);t&&t.D!==o.value&&(o.value=t.D,o.entries=t.entries,i())},d=t=>{c(),i(!0),r("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime)},h=(t,n=!1)=>{W(()=>{for(const n of t)"soft-navigation"!==n.entryType?a.l(n):d(n);c(),n&&i(!0)})},g=["event","first-input"];T(n)&&g.push("soft-navigation");const v=M(g,h,{...n,durationThreshold:n.durationThreshold??40});i=u(t,o,R,n.reportAllChanges),v&&(e.onHidden(()=>{h(v.takeRecords(),!0)}),l(()=>{r("back-forward-cache",o.navigationId,o.navigationInteractionId,o.navigationURL,f())}))})})(n=>{t(E(n))},n)},t.onLCP=(t,n={})=>{const i=s(n=Object.assign({},n),U),o=new WeakMap;T(n)&&(i.u=new Map),i.p=t=>{const e=t.element;if(e){const i=n.generateTarget?.(e)??a(e);o.set(t,i)}else t.id&&o.set(t,`#${t.id}`)};((t,n={})=>{let e=!1;const i=T(n);S(()=>{let o,a=y(),r=b("LCP");const c=s(n,U),g=(i,s,c,f,l)=>{r=b("LCP",-1,i,s,c,f,l),o=u(t,r,V,n.reportAllChanges),e=!1,"soft-navigation"===i&&(a=y(!0))},v=t=>{c.u&&t.navigationId&&E(c.u,t),e||o(!0),g("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime);const n=t.getLargestInteractionContentfulPaint?.();n&&p([n])},p=t=>{n.reportAllChanges||i||(t=t.slice(-1));for(const n of t){if(!n)continue;if("soft-navigation"===n.entryType){v(n);continue}let t=0,e=[],i=n.startTime;if("largest-contentful-paint"===n.entryType)t=Math.max(n.startTime-h(),0),c.l(n),e=[n];else if("interaction-contentful-paint"===n.entryType){const o=n;if(!r.navigationId)continue;if("interactionId"in o&&o.interactionId!=r.navigationInteractionId)continue;i=o.largestContentfulPaint?.renderTime||0,t=Math.max(i-n.startTime,0),o.largestContentfulPaint&&(c.l(o.largestContentfulPaint),e=[o.largestContentfulPaint])}i<a.firstHiddenTime&&(r.value=t,r.entries=e,o())}},m=["largest-contentful-paint"];i&&m.push("interaction-contentful-paint","soft-navigation");const T=M(m,p);if(T){o=u(t,r,V,n.reportAllChanges);const a=["keydown","click","visibilitychange"],s=t=>{if(t.isTrusted&&!e){const t=r.id;W(()=>{if(!e){if(!i){T.disconnect();for(const t of a)removeEventListener(t,s,{capture:!0})}t===r.id&&(e=!0,o(!0))}})}};for(const t of a)addEventListener(t,s,{capture:!0});l(i=>{g("back-forward-cache",r.navigationId,r.navigationInteractionId,r.navigationURL,f()),o=u(t,r,V,n.reportAllChanges),d(()=>{r.value=performance.now()-i.timeStamp,e=!0,o(!0)})})}})})(n=>{t((t=>{let n={timeToFirstByte:0,resourceLoadDelay:0,resourceLoadDuration:0,elementRenderDelay:t.value};if(t.entries.length){const a=t.entries.at(-1),r=a.url&&performance.getEntriesByType("resource").find(t=>t.name===a.url);let s;n.target=o.get(a),n.lcpEntry=a,a.url&&(n.url=a.url),r&&(n.lcpResourceEntry=r);let c=0,f=0;if("soft-navigation"!==t.navigationType?(s=e(),c=s?.activationStart??0,f=s?.responseStart??0):(c=t.navigationStartTime||0,s=i.u?.get(t.navigationId)),s){const e=Math.max(0,f-c),i=Math.max(e,r?(r.requestStart||r.startTime)-c:0),o=Math.min(t.value,Math.max(i,r?r.responseEnd-c:0));n={...n,timeToFirstByte:e,resourceLoadDelay:i-e,resourceLoadDuration:o-i,elementRenderDelay:t.value-o,navigationEntry:s}}}return Object.assign(t,{attribution:n})})(n))},n)},t.onTTFB=(t,n={})=>{((t,n={})=>{const i=T(n);let o=b("TTFB"),a=u(t,o,$,n.reportAllChanges);x(()=>{const r=e();if(r){const e=r.responseStart;o.value=Math.max(e-h(),0),o.entries=[r],a(!0),l(()=>{o=b("TTFB",0,"back-forward-cache",o.navigationId,o.navigationInteractionId,o.navigationURL,f()),a=u(t,o,$,n.reportAllChanges),a(!0)}),i&&M(["soft-navigation"],e=>{e.forEach(e=>{e.navigationId&&(o=b("TTFB",0,"soft-navigation",e.navigationId,e.interactionId,e.name,e.startTime),o.entries=[e],a=u(t,o,$,n.reportAllChanges),a(!0))})},n)}})})(n=>{t((t=>{const n=t.entries[0];let e={waitingDuration:0,cacheDuration:0,dnsDuration:0,connectionDuration:0,requestDuration:0,navigationEntry:n};if(t.entries.length&&n instanceof PerformanceNavigationTiming){const i=n.activationStart||0,o=Math.max((n.workerStart||n.fetchStart||0)-i,0),a=Math.max(n.domainLookupStart-i,0),r=Math.max(n.connectStart-i,0),s=Math.max(n.connectEnd-i,0);e={waitingDuration:o,cacheDuration:a-o,dnsDuration:r-a,connectionDuration:s-r,requestDuration:t.value-s,navigationEntry:n}}return Object.assign(t,{attribution:e})})(n))},n)},t}({});

  var config = window.LibasCwvRumConfig;
  if (!config || typeof config !== 'object') {
    return;
  }

  var debugMode = false;
  try {
    debugMode =
      new window.URLSearchParams(window.location.search).get('cwv_debug') === '1';
  } catch (error) {
    debugMode = /(?:^|[?&])cwv_debug=1(?:&|$)/.test(window.location.search);
  }

  var shopify = window.Shopify;
  if (!shopify || typeof shopify !== 'object') {
    return;
  }

  var themeRole = shopify.theme && shopify.theme.role;
  if (!debugMode && (shopify.designMode === true || themeRole !== 'main')) {
    return;
  }

  var pageTemplate = config.pageTemplate;
  var metricName;
  var deviceBucket;

  if (typeof window.matchMedia !== 'function') {
    return;
  }

  try {
    if (
      pageTemplate === 'collection' &&
      window.matchMedia('(max-width: 768px)').matches
    ) {
      metricName = 'INP';
      deviceBucket = 'mobile';
    } else if (
      pageTemplate === 'product' &&
      window.matchMedia('(min-width: 769px)').matches
    ) {
      metricName = 'CLS';
      deviceBucket = 'desktop';
    } else {
      return;
    }
  } catch (error) {
    return;
  }

  if (
    typeof config.releaseId !== 'string' ||
    config.releaseId.trim().length === 0
  ) {
    return;
  }

  var fullSampleUntil = Date.parse(config.fullSampleUntil);
  if (!isFinite(fullSampleUntil)) {
    return;
  }

  function isValidSampleRate(value) {
    return (
      typeof value === 'number' &&
      isFinite(value) &&
      value >= 0 &&
      value <= 1
    );
  }

  if (
    !isValidSampleRate(config.sampleRateDuring) ||
    !isValidSampleRate(config.sampleRateAfter)
  ) {
    return;
  }

  var sampleRate = debugMode
    ? 1
    : Date.now() < fullSampleUntil
      ? config.sampleRateDuring
      : config.sampleRateAfter;

  if (sampleRate <= 0 || Math.random() >= sampleRate) {
    return;
  }

  var state = {
    consentApiReady: false,
    observersStarted: false,
    lifecycleBound: false,
    pendingByMetricId: Object.create(null),
    lastSentValueByMetricId: Object.create(null),
  };

  function shortString(value) {
    if (value === undefined || value === null) {
      return '';
    }

    return String(value).replace(/\s+/g, ' ').slice(0, 100);
  }

  function finiteNumber(value, precision) {
    if (typeof value !== 'number' || !isFinite(value)) {
      return 0;
    }

    var factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
  }

  function queryStrippedPageLocation() {
    var origin =
      window.location.origin ||
      window.location.protocol + '//' + window.location.host;

    return shortString(origin + window.location.pathname);
  }

  function analyticsAllowed() {
    try {
      return Boolean(
        state.consentApiReady &&
          shopify.customerPrivacy &&
          typeof shopify.customerPrivacy.analyticsProcessingAllowed ===
            'function' &&
          shopify.customerPrivacy.analyticsProcessingAllowed() === true,
      );
    } catch (error) {
      return false;
    }
  }

  function clearPending() {
    state.pendingByMetricId = Object.create(null);
  }

  function commonPayload(metric, attribution, eventName, debugTarget) {
    return {
      event: shortString(eventName),
      metric_id: shortString(metric.id),
      metric_rating: shortString(metric.rating),
      debug_target: shortString(debugTarget),
      page_template: shortString(pageTemplate),
      release_id: shortString(config.releaseId),
      device_bucket: shortString(deviceBucket),
      load_state: shortString(attribution.loadState || 'unknown'),
      sample_rate: sampleRate,
      page_location: queryStrippedPageLocation(),
    };
  }

  function buildPayload(metric) {
    var attribution = metric.attribution || {};
    var payload;

    if (metricName === 'INP' && metric.name === 'INP') {
      payload = commonPayload(
        metric,
        attribution,
        'cwv_inp',
        attribution.interactionTarget,
      );
      payload.inp_value_ms = finiteNumber(metric.value, 3);
      payload.inp_delta_ms = finiteNumber(metric.delta, 3);
      payload.input_delay_ms = finiteNumber(attribution.inputDelay, 3);
      payload.processing_duration_ms = finiteNumber(
        attribution.processingDuration,
        3,
      );
      payload.presentation_delay_ms = finiteNumber(
        attribution.presentationDelay,
        3,
      );
      payload.interaction_type = shortString(
        attribution.interactionType || 'unknown',
      );
      return payload;
    }

    if (metricName === 'CLS' && metric.name === 'CLS') {
      payload = commonPayload(
        metric,
        attribution,
        'cwv_cls',
        attribution.largestShiftTarget,
      );
      payload.cls_value = finiteNumber(metric.value, 5);
      payload.cls_delta = finiteNumber(metric.delta, 5);
      payload.largest_shift_value = finiteNumber(
        attribution.largestShiftValue,
        5,
      );
      payload.largest_shift_time_ms = finiteNumber(
        attribution.largestShiftTime,
        3,
      );
      return payload;
    }

    return null;
  }

  function rememberLatest(metric) {
    if (!analyticsAllowed()) {
      clearPending();
      return;
    }

    if (!metric || typeof metric.id !== 'string' || metric.id.length === 0) {
      return;
    }

    var payload = buildPayload(metric);
    if (!payload) {
      return;
    }

    var primaryValue =
      metricName === 'INP' ? payload.inp_value_ms : payload.cls_value;

    state.pendingByMetricId[metric.id] = {
      payload: payload,
      valueKey: String(primaryValue),
    };
  }

  function flushPending() {
    var metricIds = Object.keys(state.pendingByMetricId);

    for (var index = 0; index < metricIds.length; index += 1) {
      if (!analyticsAllowed()) {
        clearPending();
        return;
      }

      var metricId = metricIds[index];
      var pending = state.pendingByMetricId[metricId];

      if (!pending) {
        continue;
      }

      if (
        state.lastSentValueByMetricId[metricId] === pending.valueKey
      ) {
        delete state.pendingByMetricId[metricId];
        continue;
      }

      try {
        if (!window.dataLayer) {
          window.dataLayer = [];
        }

        if (typeof window.dataLayer.push !== 'function') {
          return;
        }

        window.dataLayer.push(pending.payload);
        state.lastSentValueByMetricId[metricId] = pending.valueKey;
        delete state.pendingByMetricId[metricId];
      } catch (error) {
        return;
      }
    }
  }

  function bindLifecycleFlush() {
    if (state.lifecycleBound) {
      return;
    }

    state.lifecycleBound = true;

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        flushPending();
      }
    });

    window.addEventListener('pagehide', flushPending);
  }

  function startObserversIfAllowed() {
    if (state.observersStarted || !analyticsAllowed()) {
      return;
    }

    state.observersStarted = true;

    try {
      if (metricName === 'INP' && typeof webVitals.onINP === 'function') {
        webVitals.onINP(rememberLatest, {
          reportAllChanges: true,
          includeProcessedEventEntries: false,
        });
      } else if (
        metricName === 'CLS' &&
        typeof webVitals.onCLS === 'function'
      ) {
        webVitals.onCLS(rememberLatest, {
          reportAllChanges: true,
        });
      } else {
        state.observersStarted = false;
        return;
      }
    } catch (error) {
      state.observersStarted = false;
      return;
    }

    bindLifecycleFlush();

    if (document.visibilityState === 'hidden') {
      flushPending();
    }
  }

  document.addEventListener('visitorConsentCollected', function () {
    if (analyticsAllowed()) {
      startObserversIfAllowed();
    } else {
      clearPending();
    }
  });

  if (typeof shopify.loadFeatures !== 'function') {
    return;
  }

  try {
    shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) {
          return;
        }

        state.consentApiReady = true;
        startObserversIfAllowed();
      },
    );
  } catch (error) {
    return;
  }
})(window, document);

